function scrollToElem(selector) {
    const element = document.querySelector(selector);
    element && element.scrollIntoView({ behavior: 'smooth' }); 
}

function scrollToTop(offset = 0) {
    $("html, body").animate({ scrollTop: offset }, 'smooth');
}
